<template>
  <q-section v-bind="mergedWrapperProps">
    <q-section pl="12" pc="y" class="ws-nowrap">
      {{ modelValue?.slice(5).replace('-', '月') }}
    </q-section>
    <q-section wh="30 100%" pr="0" @click="handleShowDate"></q-section>
    <q-section
      key="showDateList"
      v-if="showDateList"
      p="absolute"
      pc="x"
      pt="100%"
      mt="4"
      pz="20"
      wh="74 240"
      bg-c="#fff"
      bdr="7"
      class="flex flex-col items-center day-select-dropdown">
      <q-section
        v-for="item in dates"
        wh="74 34"
        p="relative"
        :key="item"
        class="flex flex-col items-center justify-center flex-noshrink"
        @click="handleDateClick(item)">
        {{ item.slice(5).replace('-', '月') }}
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
// 补全 SFC：原文件仅有片段，无 script，无法编译/复用
import { ref, computed } from 'vue'

const defaultWrapperProps = {
  bgI: 'day-pick',
  p: 'absolute',
  f: '13 #333333 400',
  pt: '10',
  pr: '10',
} as const

const props = withDefaults(
  defineProps<{
    /** 可选日期列表，如 stage 接口返回的 dates */
    dates?: string[]
    /** 当前选中日期 YYYY-MM-DD，与 v-model 同步 */
    modelValue: string
    /** 与 uiMeta.layout.daySelect 对齐，覆盖根 q-section 默认样式 */
    wrapperProps?: Record<string, unknown>
  }>(),
  {
    dates: () => [],
    wrapperProps: () => ({}),
  }
)

const mergedWrapperProps = computed(() => ({
  ...defaultWrapperProps,
  ...(props.wrapperProps || {}),
}))

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const showDateList = ref(false)

const handleShowDate = () => {
  showDateList.value = !showDateList.value
}

const handleDateClick = (item: string) => {
  showDateList.value = false
  emit('update:modelValue', item)
}
</script>

<style scoped lang="scss">
// 防止父级裁剪下拉
.day-select-dropdown {
  overflow-y: auto;
  max-height: 60vh;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
</style>
